/* pp-megahover.js — hover intent for the header mega menu.
   Jeff: "add some intent delay to the mega menu hover expand on all sub pages.
   rolling my mouse over it to interact with the page is annoying. it doesn't
   have to be long, just so it doesn't fire all the time."

   MEASURED: the trigger is `mouseenter` on
   `header-float-element-btn.header__dropdown-toggle` (6 of them). Dispatching
   mouseenter flips the panel's aria-hidden from true to false; pointerenter
   does nothing, so mouseenter is the only event to gate.

   ⚠ THE LISTENER GOES ON `document` IN CAPTURE, NOT ON THE BUTTON. At the
   target, listeners fire in registration order regardless of the capture
   flag, so a listener added to the button after Aurora's would run second and
   could not hold it back. Capture on an ancestor runs before the target no
   matter who registered first — and capture does reach the target even for
   mouseenter, which does not bubble.

   Keyboard is deliberately untouched: focusin also opens the panel and should
   stay instant. */
(function () {
  'use strict';

  var SEL = 'header-float-element-btn.header__dropdown-toggle';
  var PANEL = 'header-float-element';

  /* ── DWELL ALONE WAS NOT INTENT ────────────────────────────────────────────
     Jeff, after the first version: "the mega menu needs a pause to check for
     intent or something. its popping open all the time and pissing me off."

     He is right, and 140ms of dwell was the wrong instrument. The old gate
     asked one question -- "is the pointer still over the button 140ms later?"
     -- which is true of any slow pass and of any momentary hesitation on the
     way to something else. Time is not intent.

     So it now asks the question hover-intent should ask: HAS THE POINTER
     SETTLED? A pointer sweeping across the nav is moving at roughly 1-3 px/ms;
     a pointer that has arrived is under about 0.1. If the dwell elapses and
     the pointer is still travelling, the menu does not open -- it looks again
     a moment later, a few times, and gives up if the pointer never settles.
     Crossing the header therefore cannot open anything at any speed, while
     stopping on an item opens it right away. */
  var DWELL = 250;        /* ms before the first look */
  var RECHECK = 120;      /* ms between looks while the pointer is still moving */
  var LOOKS = 4;          /* how many times to look before giving up */
  var WINDOW = 130;       /* ms of pointer history a look considers */
  var SETTLED = 40;       /* px of travel in that window that still counts as settled */

  var timer = null;
  var armed = null;
  var trail = [];         /* recent {x, y, t}, newest last */

  /* A pointer device only. On touch, mouseenter arrives with the tap and a
     delay would just make the menu feel broken. */
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

  function anyOpen() {
    var all = document.querySelectorAll(PANEL);
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('aria-hidden') === 'false') return true;
    }
    return false;
  }

  function cancel() {
    if (timer) { clearTimeout(timer); timer = null; }
    armed = null;
  }

  /* ⚠ passive: this runs on every mouse move in the document, so it must never
     be able to delay a scroll or a paint. It keeps a handful of samples and
     does no work beyond that. */
  document.addEventListener('mousemove', function (e) {
    trail.push({ x: e.clientX, y: e.clientY, t: Date.now() });
    if (trail.length > 16) trail.shift();
  }, { passive: true, capture: true });

  /* px travelled over the last WINDOW ms. No history yet means the pointer
     has not moved since arming, which is as settled as it gets. */
  function travel() {
    var now = Date.now(), i, first = null;
    for (i = trail.length - 1; i >= 0; i--) {
      if (now - trail[i].t > WINDOW) break;
      first = trail[i];
    }
    var last = trail[trail.length - 1];
    if (!first || !last || first === last) return 0;
    return Math.sqrt(Math.pow(last.x - first.x, 2) + Math.pow(last.y - first.y, 2));
  }

  document.addEventListener('mouseenter', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(SEL);
    if (!btn) return;
    if (e.__ppReplay) return;          /* our own replay: let it through */

    /* Already browsing the menu — switching between top-level items must feel
       instant, or moving along the nav with a panel open feels broken. */
    if (anyOpen()) return;

    e.stopPropagation();               /* hold it before it reaches the target */
    cancel();
    armed = btn;

    var looks = 0;
    function look() {
      timer = null;
      if (armed !== btn) return;
      /* Gone? A pass across the nav ends here, whatever its speed. */
      if (!btn.matches(':hover')) { armed = null; return; }
      /* Still travelling? Not intent yet -- look again shortly. */
      if (travel() > SETTLED && ++looks < LOOKS) {
        timer = setTimeout(look, RECHECK);
        return;
      }
      if (travel() > SETTLED) { armed = null; return; }   /* never settled */
      var ev = new MouseEvent('mouseenter', { bubbles: false, cancelable: true });
      ev.__ppReplay = true;
      btn.dispatchEvent(ev);
      armed = null;
    }
    timer = setTimeout(look, DWELL);
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(SEL)) cancel();
  }, true);

  /* A click should never wait. */
  document.addEventListener('pointerdown', cancel, true);
})();
